var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loyalty-page" }, [
    _c("div", { staticClass: "loyalty-landing has-text-centered" }, [
      _c("img", {
        attrs: {
          id: "friends-img",
          alt: "Friends gathered around",
          src: require("@/assets/loyalty/friends.png")
        }
      }),
      _vm._v(" "),
      _vm.points.hasAvailible
        ? _c("div", [
            _c("h2", { staticClass: "is-size-4" }, [_vm._v("🎉🍕")]),
            _vm._v(" "),
            _c("h5", { staticClass: "is-size-5 store-loyalty-text-color" }, [
              1 < _vm.points.itemsAvailable
                ? _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.points.itemsAvailable) +
                        " FREE PIZZAS ARE"
                    )
                  ])
                : _c("span", [_vm._v("A FREE PIZZA IS")]),
              _vm._v(" "),
              _c("br"),
              _vm._v("\n\t\t\t\tWAITING FOR YOU! ")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("Reedemable at checkout")])
          ])
        : _c("div", [
            _c("h5", { staticClass: "is-size-5 store-loyalty-text-color" }, [
              _vm._v("Congratulations!")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("You've earned")])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "pill-container" }, [
        _c(
          "p",
          {
            staticClass:
              "store-loyalty-text-color is-bolder loyalty-pill has-background-white reward-pill is-size-4",
            attrs: {
              tabindex: "0",
              "aria-label":
                "you have " +
                _vm.getLoyaltyPointsString +
                " " +
                _vm.$appConstants.pointsName
            }
          },
          [_vm._v("\n\t\t\t\t" + _vm._s(_vm.getLoyaltyPointsString))]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$appConstants.pointsName) + " "),
        _c("br"),
        _vm._v(
          " Earn " +
            _vm._s(_vm.points.pointsNeeded.toLocaleString()) +
            " more points for your\n\t\t\t"
        ),
        _vm.points.available ? _c("span", [_vm._v("next")]) : _vm._e(),
        _vm._v(" FREE pizza")
      ]),
      _vm._v(" "),
      _vm.hasCouponOffers()
        ? _c(
            "div",
            { staticClass: "loyalty-offer-coupons" },
            [
              _c("br"),
              _vm._v(" "),
              _c("h2", { staticClass: "is-size-5 store-loyalty-text-color" }, [
                _vm._v("You have the following coupons available:")
              ]),
              _vm._v(" "),
              _vm._l(_vm.getCouponOffers(), function(offerCoupon) {
                return _c("div", { key: offerCoupon.uniqueId }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          return _vm.getItemRouteIfAvailable(offerCoupon)
                        }
                      }
                    },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "is-size-5 store-loyalty-text-color offer-background"
                        },
                        [_vm._v(_vm._s(offerCoupon.name))]
                      )
                    ]
                  )
                ])
              })
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "redemption-section" }, [
      _c("div", { staticClass: "redemption-body" }, [
        _c("div", { staticClass: "redemption-body-section" }, [
          _c("h5", { staticClass: "is-size-5 store-loyalty-text-color " }, [
            _vm._v("How do I earn my free Pizza?")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Simple, for each $1 spent, you earn " +
                _vm._s(_vm.franchisor.loyaltyPointsForPurchaseFactor * 100) +
                "\n\t\t\t\t\t" +
                _vm._s(_vm.$appConstants.pointsName) +
                "."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "After " +
                _vm._s(_vm.franchisor.loyaltyPointsPerReward) +
                " " +
                _vm._s(_vm.$appConstants.pointsName) +
                " earned, we reward you with a "
            ),
            _c("span", { staticClass: "store-navigation-color" }, [
              _vm._v("FREE PIZZA!")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Every purchase counts. Online, in store or via Phone. Delivery or Pickup"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "redemption-body-section" }, [
          _c("h5", { staticClass: "is-size-5 store-loyalty-text-color " }, [
            _vm._v("How can I get my free Pizza?")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Once you've earned " +
                _vm._s(_vm.franchisor.loyaltyPointsPerReward) +
                " " +
                _vm._s(_vm.$appConstants.pointsName) +
                ", you receive a\n\t\t\t\t\tFREE-PIZZA-COUPON in the online store. Or simply ask any Pizza Guy in any store for your reward.\n\t\t\t\t\tThey will happily take care of you. "
            )
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          target: "_blank",
          href: "https://www.touchpoint.io/terms",
          rel: "noopener"
        }
      },
      [_c("u", [_vm._v("View Terms of Service")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58a042fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58a042fd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loyalty/Loyalty.vue
// module id = null
// module chunks = 